import {Component, OnInit} from '@angular/core';
import { Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ModalController} from '@ionic/angular';
import {AppComponent} from '../../app.component';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import {sleep} from '../../../smoothr-web-app-core/utils/utils';
import Table from '../../../smoothr-web-app-core/models/Table';
import {Api} from '../../../smoothr-web-app-core/api/api';
import {TranslateService} from '@ngx-translate/core';

@Component({
	selector: 'app-scan-qr',
	templateUrl: './scan-qr.component.html',
	styleUrls: ['./scan-qr.component.scss']
})
export class ScanQrModal implements OnInit {
	scanning = true;

	constructor(
		private modalCtrl: ModalController,
	) {}

	static async show(modalCtrl: ModalController): Promise<string> {
		const resultScan = await modalCtrl.create({
			component: ScanQrModal,
			cssClass: 'scan-modal',
			componentProps: {}
		});
		await resultScan.present();
		const res = (await resultScan.onDidDismiss()).data;
		await sleep(100);
		return res;
	}
	ngOnInit() {}
	
	close() {
		this.modalCtrl.dismiss();
	}

	startScanning() {
		this.scanning = true;
	}

	stopScanning() {
		this.scanning = false;
	}


	scanSuccessHandler($event: string) {
		this.stopScanning();

		this.modalCtrl.dismiss($event)
	}

}
